import React from "react";
import PropTypes from "prop-types";
import Button from "../elements/button";

const ListboxInfoBar = ({ count, showSelectedOnly, onClear, onShowSelected, disableShowSelected }) => {
  return (
    <div className="et-listbox--infobar">
      <div>
        <span className="et-listbox--infobar-count">{count}</span>
        <Button
          disabled={!count}
          className="et-listbox--infobar-link"
          type="simple"
          onClick={() => {
            onClear();
            onShowSelected(false);
          }}
        >
          Clear
        </Button>
      </div>
      <div className="et-listbox--show-selected">
        {showSelectedOnly ? (
          <Button
            label="Show all items"
            className="et-listbox--infobar-link"
            type="simple"
            onClick={() => onShowSelected(false)}
          >
          View All
          </Button>
        ) : (
          <span className="et-listbox--infobar-text">View All</span>
        )}
        <span className="et-listbox--infobar-separator">|</span>
        {showSelectedOnly ? (
          <span className="et-listbox--infobar-text">View Selected</span>
        ) : (
          <Button
            label="Show selected items only"
            disabled={!count || disableShowSelected}
            className="et-listbox--infobar-link"
            type="simple"
            onClick={() => onShowSelected(true)}
          >
          View Selected
          </Button>
        )}
      </div>
    </div>
  );
};

ListboxInfoBar.propTypes = {
  count: PropTypes.number.isRequired,
  showSelectedOnly: PropTypes.bool.isRequired,
  onClear: PropTypes.func.isRequired,
  onShowSelected: PropTypes.func.isRequired,
  disableShowSelected: PropTypes.bool.isRequired,
};

export default ListboxInfoBar;
